import Section from './Section.vue'
import { getTierEffectiveMin, sortAgentBoxTiersByInviteAsc } from './tierSort'

const REWARD_RANDOM = 1
const REWARD_FIXED = 2
const NUM_GTE = 1
const NUM_GT = 2
const DURATION_FOREVER = 2

function createEmptyAgentBoxTier() {
  return {
    id: '',
    need_share_one_num: 1,
    num_interval_type: NUM_GTE,
    reward_type: REWARD_RANDOM,
    reward_count_min: 0,
    reward_count_max: 0,
    reward_count: 0,
    available_num: 0,
  }
}

function normalizeTierFromApi(tier, ctx) {
  const { centsToYuanNumber } = ctx
  const rewardType = Number(tier?.reward_type) === REWARD_FIXED ? REWARD_FIXED : REWARD_RANDOM
  const needRaw = Number.isFinite(Number(tier?.need_share_one_num)) ? Number(tier.need_share_one_num) : 1
  const wasGt = Number(tier?.num_interval_type) === NUM_GT
  const effectiveMin = wasGt ? needRaw + 1 : needRaw
  const base = {
    id: tier?.id != null ? String(tier.id) : '',
    need_share_one_num: Math.max(1, effectiveMin),
    num_interval_type: NUM_GTE,
    reward_type: rewardType,
    available_num: Number.isFinite(Number(tier?.available_num)) ? Number(tier.available_num) : 0,
  }
  if (rewardType === REWARD_RANDOM) {
    const arr = Array.isArray(tier?.reward_count_arr) ? tier.reward_count_arr : []
    const a = arr[0]
    const b = arr[1]
    return {
      ...base,
      reward_count_min: centsToYuanNumber(Number(a) || 0),
      reward_count_max: centsToYuanNumber(Number(b) || 0),
      reward_count: 0,
    }
  }
  return {
    ...base,
    reward_count_min: 0,
    reward_count_max: 0,
    reward_count: centsToYuanNumber(Number(tier?.reward_count) || 0),
  }
}

export const agentRewardBoxModule = {
  type: 6,
  component: Section,
  reset(localForm, ctx) {
    const { agentBoxRuleFlags, agentBoxRuleValues } = localForm
    if (agentBoxRuleFlags) {
      agentBoxRuleFlags.bet = false
      agentBoxRuleFlags.payin = false
    }
    if (agentBoxRuleValues) {
      agentBoxRuleValues.bet_amount = undefined
      agentBoxRuleValues.payin_amount = undefined
      agentBoxRuleValues.multiple = 1
    }
    localForm.agentBoxTiers = [createEmptyAgentBoxTier()]
  },
  fillFromActivity(localForm, raw, ctx) {
    const { centsToYuanNumber } = ctx
    const cfg = raw.agent_reward_box_config || raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    const betAmt = Number(rule.bet_amount)
    const payAmt = Number(rule.payin_amount)
    localForm.agentBoxRuleFlags.bet = Number.isFinite(betAmt) && betAmt > 0
    localForm.agentBoxRuleFlags.payin = Number.isFinite(payAmt) && payAmt > 0
    localForm.agentBoxRuleValues.bet_amount = localForm.agentBoxRuleFlags.bet ? centsToYuanNumber(betAmt) : undefined
    localForm.agentBoxRuleValues.payin_amount = localForm.agentBoxRuleFlags.payin ? centsToYuanNumber(payAmt) : undefined
    localForm.agentBoxRuleValues.multiple = Number.isFinite(Number(rule.multiple)) ? Number(rule.multiple) : 1

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    if (rawTiers.length > 0) {
      localForm.agentBoxTiers = sortAgentBoxTiersByInviteAsc(rawTiers.map(t => normalizeTierFromApi(t, ctx)))
    } else {
      localForm.agentBoxTiers = [createEmptyAgentBoxTier()]
    }
  },
  validate(localForm, ctx) {
    const { Message } = ctx
    const flags = localForm.agentBoxRuleFlags
    const values = localForm.agentBoxRuleValues

    const hasBet = flags.bet && Number(values.bet_amount) > 0
    const hasPayin = flags.payin && Number(values.payin_amount) > 0
    if (!hasBet && !hasPayin) {
      Message.error('请至少勾选一项有效人数规则并填写金额')
      return false
    }
    if (flags.bet && (!Number.isFinite(Number(values.bet_amount)) || Number(values.bet_amount) <= 0)) {
      Message.error('请输入累计投注达到金额')
      return false
    }
    if (flags.payin && (!Number.isFinite(Number(values.payin_amount)) || Number(values.payin_amount) <= 0)) {
      Message.error('请输入累计存款达到金额')
      return false
    }
    const mult = Number(values.multiple)
    if (!Number.isFinite(mult) || mult <= 0) {
      Message.error('请输入大于0的奖励稽核倍数')
      return false
    }

    const tiers = localForm.agentBoxTiers || []
    if (tiers.length === 0) {
      Message.error('请至少配置一条邀请档位')
      return false
    }

    for (let i = 0; i < tiers.length; i += 1) {
      const t = tiers[i]
      const row = i + 1
      const need = Number(t.need_share_one_num)
      if (!Number.isFinite(need) || need <= 0) {
        Message.error(`第${row}行累计有效人数须大于0`)
        return false
      }
    }
    const sortedTiers = sortAgentBoxTiersByInviteAsc(tiers)
    for (let i = 1; i < sortedTiers.length; i += 1) {
      const prev = getTierEffectiveMin(sortedTiers[i - 1])
      const cur = getTierEffectiveMin(sortedTiers[i])
      if (cur <= prev) {
        Message.error('邀请档位须按邀请人数从小到大配置，且门槛不能重复或冲突')
        return false
      }
    }
    localForm.agentBoxTiers = sortedTiers

    for (let i = 0; i < sortedTiers.length; i += 1) {
      const t = sortedTiers[i]
      const row = i + 1
      const rt = Number(t.reward_type)
      if (rt === REWARD_RANDOM) {
        const min = Number(t.reward_count_min)
        const max = Number(t.reward_count_max)
        if (!Number.isFinite(min) || min < 0 || !Number.isFinite(max) || max < 0) {
          Message.error(`第${row}行随机奖励区间须填写合法数字`)
          return false
        }
        if (max < min) {
          Message.error(`第${row}行随机奖励上限须大于等于下限`)
          return false
        }
      } else {
        const rc = Number(t.reward_count)
        if (!Number.isFinite(rc) || rc <= 0) {
          Message.error(`第${row}行固定奖励金额须大于0`)
          return false
        }
      }
    }
    return true
  },
  buildPayload(localForm, ctx) {
    const { yuanToCents } = ctx
    const flags = localForm.agentBoxRuleFlags
    const values = localForm.agentBoxRuleValues

    const rule = {
      bet_amount: flags.bet && values.bet_amount != null ? yuanToCents(Number(values.bet_amount)) : 0,
      payin_amount: flags.payin && values.payin_amount != null ? yuanToCents(Number(values.payin_amount)) : 0,
      multiple: Number(values.multiple) || 0,
      duration_type: DURATION_FOREVER,
      duration: 0,
    }

    const tiers = sortAgentBoxTiersByInviteAsc(localForm.agentBoxTiers || []).map(t => {
      const rewardType = Number(t.reward_type) === REWARD_FIXED ? REWARD_FIXED : REWARD_RANDOM
      const base = {
        id: t.id != null && t.id !== '' ? String(t.id) : '',
        need_share_one_num: Number(t.need_share_one_num) || 0,
        num_interval_type: NUM_GTE,
        reward_type: rewardType,
        available_num: Number.isFinite(Number(t.available_num)) ? Number(t.available_num) : 0,
      }
      if (rewardType === REWARD_RANDOM) {
        return {
          ...base,
          reward_count: 0,
          reward_count_arr: [
            yuanToCents(Number(t.reward_count_min)) || 0,
            yuanToCents(Number(t.reward_count_max)) || 0,
          ],
        }
      }
      return {
        ...base,
        reward_count: yuanToCents(Number(t.reward_count)) || 0,
      }
    })

    return {
      agent_reward_box_config: {
        description: '',
        rule,
        tiers,
      },
    }
  },
}
